/*
 *  Constants for B2I org names
 */
export enum B2I_ORG_NAMES {
  CUSTOMERS_B2I = 'CUSTOMERS_B2I',
  PARTNERS_B2I = 'PARTNERS_B2I',
}
